export const summaryCards = [
  { label: "Toplam Veli / Öğrenci", value: "243", icon: "ri-team-line", color: "emerald", change: "+8 bu ay" },
  { label: "Bugün Gönderilecek Mesaj", value: "18", icon: "ri-message-3-line", color: "sky", change: "6 tamamlandı" },
  { label: "Yarın Ödeme Günü Olanlar", value: "24", icon: "ri-calendar-check-line", color: "amber", change: "Yarın 09:00" },
  { label: "Bu Ay Referans İstenecekler", value: "126", icon: "ri-user-add-line", color: "violet", change: "48 yapıldı" },
  { label: "Taahhüdü Yaklaşan Öğrenciler", value: "11", icon: "ri-file-list-3-line", color: "orange", change: "30 gün içinde" },
  { label: "Bekleyen WhatsApp Mesajları", value: "141", icon: "ri-whatsapp-line", color: "emerald", change: "Sırada bekliyor" },
];

export const todayTasks = [
  { text: "Bugün ödeme hatırlatması gönderilecek", count: 18, type: "payment", color: "amber" },
  { text: "Yarın ödeme günü olan", count: 24, type: "tomorrow", color: "sky" },
  { text: "30 gün içinde taahhüdü bitecek", count: 11, type: "commitment", color: "orange" },
  { text: "Referans istenecek", count: 126, type: "referral", color: "emerald" },
];

export const activeCampaign = {
  name: "Mayıs Referans Kampanyası",
  progress: 42,
  total: 243,
  sent: 102,
  pending: 141,
  nextSend: "Yaklaşık 6 dakika içinde",
  status: "Aktif",
};

export const recentActivity = [
  { icon: "ri-checkbox-circle-line", color: "emerald", text: "Ayşe Yılmaz kişisine ödeme hatırlatma mesajı gönderildi", time: "2 dk önce" },
  { icon: "ri-time-line", color: "amber", text: "Mehmet Demir için referans mesajı bekliyor", time: "8 dk önce" },
  { icon: "ri-rocket-line", color: "sky", text: "Mayıs Referans Kampanyası başlatıldı", time: "1 saat önce" },
  { icon: "ri-upload-2-line", color: "violet", text: "Yeni veli listesi içe aktarıldı", time: "3 saat önce" },
  { icon: "ri-notification-3-line", color: "orange", text: "Taahhüt bitiş hatırlatması oluşturuldu", time: "5 saat önce" },
  { icon: "ri-send-plane-line", color: "emerald", text: "Fatma Kaya\'ya taahhüt bitiş uyarısı gönderildi", time: "6 saat önce" },
];

export const dailyMessageData = [
  { gun: "Pzt", sayi: 32 },
  { gun: "Sal", sayi: 45 },
  { gun: "Çrş", sayi: 28 },
  { gun: "Prş", sayi: 51 },
  { gun: "Cum", sayi: 38 },
  { gun: "Cmt", sayi: 22 },
  { gun: "Paz", sayi: 19 },
];

export const messageStatusData = [
  { label: "Gönderildi", value: 512, color: "#25D366" },
  { label: "Bekliyor", value: 141, color: "#F59E0B" },
  { label: "Hatalı", value: 23, color: "#EF4444" },
];